import config from 'Config'; /* eslint-disable-line */
import store from '../../';

export default async (capital, roundupsEnabled) => {
  const authUser = store.getState().user;
  return fetch(
    `${config.apiUrl}/users/funding/source/reauth/sendEmail?capital=${capital}&roundupsEnabled=${roundupsEnabled}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: authUser.access_token,
        'grifin-user-key': authUser.publicKey,
      },
    },
  )
    .then(async (response) => {
      if (response.status !== 200 || false) {
        throw new Error(response.statusText);
      }
      return response;
    })
    .then(async (response) => {
      const json = await response.json();

      return { success: true, data: json };
    })
    .catch((error) => ({ error }));
};
